
var utils = new function () {
  this.getTodaysDate = function () {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = '0' + dd
    }
    if (mm < 10) {
      mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd;
    return today;
  }

  this.getPrevDate = function (prev) {
    var currDate = new Date();
    currDate.setDate(currDate.getDate() - parseInt(prev, 10));

    var dd = currDate.getDate();
    var mm = currDate.getMonth() + 1; //January is 0!
    var yyyy = currDate.getFullYear();
    if (dd < 10) {
      dd = '0' + dd
    }
    if (mm < 10) {
      mm = '0' + mm
    }
    currDate = yyyy + '-' + mm + '-' + dd;
    return currDate;
  }
}()

module.exports = utils;